import { useInView } from 'framer-motion';
import { useRef } from 'react';

// Premium scroll animation variants
export const scrollAnimationVariants = {
  fadeUp: {
    hidden: { opacity: 0, y: 60 },
    visible: { opacity: 1, y: 0 },
  },
  fadeDown: {
    hidden: { opacity: 0, y: -60 },
    visible: { opacity: 1, y: 0 },
  },
  fadeLeft: {
    hidden: { opacity: 0, x: -80 },
    visible: { opacity: 1, x: 0 },
  },
  fadeRight: {
    hidden: { opacity: 0, x: 80 },
    visible: { opacity: 1, x: 0 },
  },
  scaleUp: {
    hidden: { opacity: 0, scale: 0.8 },
    visible: { opacity: 1, scale: 1 },
  },
  scaleRotate: {
    hidden: { opacity: 0, scale: 0.9, rotate: -3 },
    visible: { opacity: 1, scale: 1, rotate: 0 },
  },
  staggerContainer: {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.12,
        delayChildren: 0.1,
      },
    },
  },
  staggerItem: {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
  },
};

// Premium transition presets
export const transitionPresets = {
  smooth: { duration: 0.8 },
  bounce: { duration: 0.8, type: 'spring' as const, stiffness: 100 },
  elegant: { duration: 1 },
  spring: { type: 'spring' as const, stiffness: 100, damping: 15 },
  slow: { duration: 1.2 },
};

// Hook for scroll animations
export const useScrollAnimation = (options?: {
  once?: boolean;
  margin?: `${number}px` | `${number}%` | `${number}px ${number}px` | `${number}px ${number}px ${number}px ${number}px`;
  amount?: 'some' | 'all' | number;
}) => {
  const ref = useRef(null);
  const isInView = useInView(ref, {
    once: options?.once ?? true,
    margin: options?.margin ?? '-80px',
    amount: options?.amount,
  });

  return { ref, isInView };
};

export default useScrollAnimation;
